import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type SearchAlertsSearchModalXinglet = XingletInterface;

export const SearchAlertsSearchModal = JobsXingletWrapper(
  '@xing-com/crate-jobs-domain-search-alerts-search-modal'
);
